import moment from 'moment';
import momentTz from 'moment-timezone';
import RouteMap from '../components/RouteDetailMapV2.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import i18n from '../locales';
import store from '../store';
import axios from 'axios';
import routeDetailModalV2Escl from '../locales/es-CL/routeDetailModalV2.json';
import routeDetailModalV2Esmx from '../locales/es-MX/routeDetailModalV2.json';
import routeDetailModalV2Esco from '../locales/es-CO/routeDetailModalV2.json';
import routeDetailModalV2Enus from '../locales/en-US/routeDetailModalV2.json';
import routeDetailModalEscl from '../locales/es-CL/routeDetailModal.json';
import routeDetailModalEsmx from '../locales/es-MX/routeDetailModal.json';
import routeDetailModalEsco from '../locales/es-CO/routeDetailModal.json';
import routeDetailModalEnus from '../locales/en-US/routeDetailModal.json';
import showRouteDetail from '../routeDetailModal/routeDetailModalHandler';
import { v1 as uuidv1 } from 'uuid';
import { CHANNEL } from '../constants/utils';
const EVENT_ICON_MAP = {
  'ROUTE.CREATION': require('@/assets/add_circle_outline_purple.svg'),
  'ROUTE.CANCEL': require('@/assets/cancel_red.svg'),
  'ASSIGNATION.ASSIGN': require('@/assets/directions_car.svg'),
  'ASSIGNATION.UNASSIGN': require('@/assets/directions_car.svg'),
  'ROUTE.START': require('@/assets/route.svg'),
  'ROUTE.END': require('@/assets/EndRoute.svg'),
  'TRIP.START': require('@/assets/location_on.svg'),
  'TRIP.ARRIVE': require('@/assets/location_on.svg'),
  'TRIP.END': require('@/assets/detention_watch.svg'),
  101: require('@/assets/events/eventsWithOrange/aperturaPuertas.svg'),
  102: require('@/assets/events/eventsWithOrange/detencionExcesiva.svg'),
  103: require('@/assets/events/eventsWithOrange/excesoVelocidad.svg'),
  104: require('@/assets/events/eventsWithOrange/excesoVelocidadFlota.svg'),
  105: require('@/assets/events/eventsWithOrange/desconexionElectrica.svg'),
  106: require('@/assets/events/eventsWithOrange/perdidaUbicacionGps.svg'),
  107: require('@/assets/events/eventsWithOrange/salidaRuta.svg'),
  108: require('@/assets/events/eventsWithOrange/interferenciaGps.svg'),
  109: require('@/assets/events/eventsWithOrange/botonPanico.svg'),
  'ROUTE.EDIT': require('@/assets/edit_purple.svg'),
  'TRIP.EDIT': require('@/assets/edit_purple.svg'),
  'ACTIVITY.EDIT': require('@/assets/edit_purple.svg'),
};

const EVENT_NAME_MAP = {
  'ROUTE.CREATION': 'routeCreated',
  'ROUTE.CANCEL': 'routeCancel',
  'ASSIGNATION.ASSIGN': 'routeAssign',
  'ASSIGNATION.UNASSIGN': 'routeUnassign',
  'ROUTE.START': 'routeStart',
  'ROUTE.END': 'routeEnd',
  'TRIP.START': 'tripStart',
  'TRIP.ARRIVE': 'tripArrival',
  'TRIP.END': 'tripEnd',
  'ROUTE.EDIT': 'routeEdit',
  'TRIP.EDIT': 'routeEdit',
  'ACTIVITY.EDIT': 'routeEdit',
};

const EVENT_PLANNED_TITLE_MAP = {
  'TRIP.START': 'startDate',
  'TRIP.ARRIVE': 'arrivalDate',
  'TRIP.END': 'endedReal',
};

export default {
  name: 'route-detail-modal-v2',
  props: ['idRoute', 'events'],
  components: { GoogleMapsApiLoader, RouteMap },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 50],
      visible: false,
      dataAccess: null,
      route: {
        state: 'NOTSTARTED',
      },
      routeName: '',
      startDate: '',
      endDate: '',
      trips: [],
      eventsInRoute: [],
      totalRows: 0,
      allowAutoPageChange: true,
      socket: {},
      gapi: null,
      selectedTab: 'seguimiento',
      secureZones: null,
      speedChangeDirection: null, // 'up', 'down' o null
      isBitacoraBussy: false,
      isCollapseClicked: false,
      isRouteDetailBusy: false,
      routeIsOngoing: false,
      isLatestDetailBusy: false,
      isMapBussy: false,
      collapseStates: {},
      actualAsignation: null,
      eventsLog: [],
      historyRoute: [],
      listOfIdsVehicle: [],
      listOfIdsCargo: [],
      listOfIdsGpsControl: [],
      actualLocationCargo: null,
      actualLocationGpsControl: null,
      showOrderMenu: false,
      orderType: 'asc',
      hoveredOrder: null,
      actualInfoVehicle: {
        id: null,
        speed: null,
        gpsDate: 0,
        state: null,
        lat: 0,
        lon: 0,
      },
      showLatestRow2: false,
      signalGpsLoaded: false,
      signalGpsLoading: false,
      lastSignalGPS: null,
      vehicleDetails: {
        id: null,
        plate: null,
        equipments: [],
        configuredAlerts: [],
      },
      truckDetails: {
        id: null,
        plate: null,
        equipments: [],
        configuredAlerts: [],
      },
      showTrafficLevel: false,
      showZones: false,
      bodyHistoryRequest: [],
      statusHistoryTimeoutIds: {},
      clientAreas: [],
      normalizedZones: [],
      zone: {
        id: null,
        name: null,
        color: null,
        points: [],
      },
    };
  },
  async created() {
    this.isRouteDetailBusy = true;
    this.isLatestDetailBusy = true;
    this.isMapBussy = true;
    await GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    await this.getData();
    this.routeIsOngoing = this.route.state === 'ONGOING';
    if (this.routeIsOngoing) {
      await this.buildVehicleAndTruckDetails();
      await this.connectToSocket();
    }
    let assignVehicleDriver = new Map();
    if (this.route.assignations != null && this.route.assignations.length > 0) {
      this.route.assignations.forEach((assign) => {
        assignVehicleDriver.set(assign.id, [assign.driver, assign.vehicle, assign.state, assign.cargo]);
      });
    }
    this.prepareTrips(assignVehicleDriver);
    this.isRouteDetailBusy = false;
    await this.prepareVehicleRealTimeData();

    if (this.secureZones == null) {
      this.secureZones = await this.getSecureRoutes();
    }
    this.clientAreas = await this.getClientAreas();
    this.normalizedZones = this.normalizeAreaZones(this.clientAreas);
    let idSpot = [];
    this.addWaypointSpots(this.secureZones, idSpot);
    await this.waitForElm('#googleMap');
    if (this.selectedTab == 'seguimiento') {
      await this.$refs.googleMap.setMapTrips(this.trips, this.showZones ? this.normalizedZones : null);
      await this.$refs.googleMap.setEvents(this.eventsInRoute);
    }
    this.isMapBussy = false;
  },
  mounted() {
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      routeDetailModalV2: routeDetailModalV2Escl,
      routeDetailModal: routeDetailModalEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      routeDetailModalV2: routeDetailModalV2Esmx,
      routeDetailModal: routeDetailModalEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      routeDetailModalV2: routeDetailModalV2Esco,
      routeDetailModal: routeDetailModalEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      routeDetailModalV2: routeDetailModalV2Enus,
      routeDetailModal: routeDetailModalEnus,
    });

    document.addEventListener('click', this.onOutsideInfoWindowClick, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutsideInfoWindowClick, true);
  },
  methods: {
    setOrderType(type) {
      this.orderType = type;
      this.showOrderMenu = false;
      this.sortEventsLogByDate(type);
    },
    onOutsideInfoWindowClick(event) {
      const target = event.target;
      const legendAnchor = document.querySelector('.legend-menu-anchor');
      const filterAnchor = document.querySelector('.filter-menu-anchor');

      const clickedInsideLegend = legendAnchor && legendAnchor.contains(target);
      const clickedInsideFilter = filterAnchor && filterAnchor.contains(target);

      if (!clickedInsideLegend) {
        const legendToggle = document.getElementById('legend-menu-toggle');
        if (legendToggle && legendToggle.checked) legendToggle.checked = false;
      }

      if (!clickedInsideFilter) {
        const filterToggle = document.getElementById('filter-menu-toggle');
        if (filterToggle && filterToggle.checked) filterToggle.checked = false;
      }
    },
    async getData() {
      this.route = await this.getRouteDetail();
      this.trips = this.route.trips;
      this.eventsInRoute = await this.events;
      this.getEventLogRoute();
      this.routeName = this.route.name;
      this.startDate = this.route.startDate;
      this.endDate = this.route.endDate;
      this.totalRows = this.eventsInRoute ? this.eventsInRoute.length : 0;
    },
    async getEventLogRoute() {
      this.isBitacoraBussy = true;
      try {
        const url = `${store.getters.urlAPI}/event?idRoute=${this.idRoute}`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        if (response.status) {
          this.eventsLog = response.data.data;
          this.buildEventsFromBd();
          this.isBitacoraBussy = false;
        }
      } catch (e) {
        console.log(e);
        this.isBitacoraBussy = false;
        this.eventsLog = [];
      }
    },
    buildEventsFromBd() {
      const uniqueMap = new Map();
      const MOVING_EVENTS = ['TRIP.START', 'TRIP.ARRIVE', 'TRIP.END', 'ROUTE.START', 'ROUTE.END'];
      const EXCLUDING_EVENTS = ['TRIP.CRON', 'TRIP.POSTPONING', 'TRIP.RESTART'];

      this.eventsLog.forEach((event) => {
        // Ajusta metaData y createdAt
        if (event.metaData) {
          event.metaData = JSON.parse(event.metaData);
          const actualCreatedDate = this.getAssignMetadata(event.metaData, 'actual_created_date');
          // Si el eventType es MOVING_EVENT y no tiene ninguna fecha real, descarta el evento
          const eventTypeStr = event.eventType?.toString().toUpperCase();
          if(EXCLUDING_EVENTS.includes(eventTypeStr)){
            return;
          }
          if (
            MOVING_EVENTS.includes(eventTypeStr) &&
            (actualCreatedDate === null || actualCreatedDate === '-' || actualCreatedDate === undefined)
          ) {
            // No agregar este evento, lo descartas
            return;
          }
          if (actualCreatedDate !== null && actualCreatedDate !== '-' && actualCreatedDate !== undefined) {
            event.createdAt = actualCreatedDate;
          }
        }
        this.$set(this.collapseStates, 'bitacora' + event.id, false);

        // Filtrado de duplicados
        const key = `${event.routeId}_${event.assignationId}_${event.tripId}_${event.eventType}_${event.createdAt}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, event);
        } else {
          const existing = uniqueMap.get(key);
          if (existing.retroacomplishment && !event.retroacomplishment) {
            uniqueMap.set(key, event);
          }
        }
      });
      // Reemplaza eventsLog con los valores únicos
      this.eventsLog = Array.from(uniqueMap.values());
      this.fullfillDataEvents();
    },
    findTripIdAndIndexForEvent(event) {
      if (!event || !this.trips || !Array.isArray(this.trips)) return { id: null, index: null };

      // Los viajes deben estar ordenados por startDate ascendente
      const sortedTrips = this.trips.slice().sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
      const foundIndex = sortedTrips.findIndex((trip) => {
        const startRaw = trip.actualStartDate || trip.startDate;
        const endRaw = trip.actualEndDate || trip.endDate;
        const eventRaw = event.initEvent;

        const start = startRaw ? new Date(startRaw).getTime() : null;
        const end = endRaw ? new Date(endRaw).getTime() : null;
        const eventTime = eventRaw ? new Date(eventRaw).getTime() : null;

        if (start === null || end === null || eventTime === null) return false;
        return eventTime >= start && eventTime <= end;
      });
      let originAddress = null;
      let destinationAddress = null;

      if (foundIndex >= 0) {
        const trip = sortedTrips[foundIndex];
        if (trip.origin?.address?.fullAddress) {
          originAddress = trip.origin.address.fullAddress;
        }
        if (trip.destination?.address?.fullAddress) {
          destinationAddress = trip.destination.address.fullAddress;
        }
      }

      const id = foundIndex >= 0 ? sortedTrips[foundIndex].id : null;
      const index = foundIndex >= 0 ? foundIndex : null;
      return { id, index, originAddress, destinationAddress };
    },
    fullfillDataEvents() {
      this.eventsInRoute.forEach((event) => {
        const {
          id: tripId,
          index: tripIndex,
          originAddress,
          destinationAddress,
        } = this.findTripIdAndIndexForEvent(event);
        if (event.initEvent && event.endEvent && event.endEvent > event.initEvent) {
          const startSec = this.normalizeToSeconds(event.initEvent);
          const endSec = this.normalizeToSeconds(event.endEvent);
          event.duration = this.formatDuration(endSec - startSec);
        } else {
          event.duration = this.t('routeDetailModalV2.noApply');
        }
        const body = {
          id: uuidv1(),
          tripId: tripId,
          entityType: 'Alert',
          eventType: event.eventType,
          createdAt: event.initEvent,
          username: 'System',
          metaData: {
            vehicle: event.plate,
            driver: event.driver,
            eventAddress: event.address,
            duration: event.duration,
            origin: originAddress,
            destination: destinationAddress,
            nameEvent: event.nameEvent.toLowerCase(),
            nameTrip: tripIndex !== null ? `Viaje ${tripIndex + 1}` : null,
          },
        };
        this.eventsLog.push(body);
      });
      this.sortEventsLogByDate('asc');
    },
    sortEventsLogByDate(order = 'desc') {
      if (!Array.isArray(this.eventsLog)) return;
      const EVENT_TYPE_PRIORITY = {
        'ROUTE.START': 1,
        'TRIP.START': 2,
        'TRIP.ARRIVE': 3,
        'TRIP.END': 4,
        'ROUTE.END': 5,
      };
      this.eventsLog = this.eventsLog.sort((a, b) => {
        // 1. Ordena por fecha
        const dateA = new Date(a.createdAt).getTime();
        const dateB = new Date(b.createdAt).getTime();
        if (dateA !== dateB) {
          return order === 'asc' ? dateA - dateB : dateB - dateA;
        }

        // 2. Si la fecha es igual, ordena por tripId
        const tripA = a.tripId !== null && a.tripId !== undefined ? a.tripId : -1;
        const tripB = b.tripId !== null && b.tripId !== undefined ? b.tripId : -1;
        if (tripA !== tripB) {
          return order === 'asc' ? tripA - tripB : tripB - tripA;
        }

        // 3. Si fecha y tripId son iguales, ordena por prioridad de tipo de evento
        const typeA = EVENT_TYPE_PRIORITY[a.eventType?.toString().toUpperCase()] || 99;
        const typeB = EVENT_TYPE_PRIORITY[b.eventType?.toString().toUpperCase()] || 99;
        return order === 'asc' ? typeA - typeB : typeB - typeA;
      });
      console.log('Eventos ordenados: ', this.eventsLog.length);
    },
    async connectToSocket() {
      const url = `${store.getters.urlWebSocketRealTimeRoute}?at=${store.getters.accessToken}`;
      this.socket = await new WebSocket(url);
      this.socket.onopen = () => {
        console.log('Websocket real time route connected.');
      };
      this.socketOnMessage();
    },
    prepareTrips(assignVehicleDriver) {
      this.$set(this.collapseStates, 'eventsRoute', true);
      this.trips = this.trips.sort((a, b) => {
        const aDate = new Date(a.startDate).getTime();
        const bDate = new Date(b.startDate).getTime();
        return aDate - bDate;
      });
      this.trips.forEach((trip, idx) => {
        this.$set(this.collapseStates, trip.id, false);
        this.transformTrip(trip, idx, assignVehicleDriver);
        if (trip.state === 'INTRANSIT') {
          this.toggleCollapse(trip.id, idx, trip.idAssignation);
        }
      });
    },
    async prepareVehicleRealTimeData() {
      if (this.routeIsOngoing || this.route.state === 'ENDED' || this.route.state === 'ENDEDINCOMPLETE') {
        const listOfIdsVehicle_socket = await this.getVehicleToListen();
        if (this.routeIsOngoing) {
          this.getRealTimeGPSVehicle(listOfIdsVehicle_socket);
          if (this.actualInfoVehicle.lat != null && this.actualInfoVehicle.lon != null) {
            if (this.selectedTab == 'seguimiento') {
              this.$refs.googleMap.setMapRealTime(this.historyRoute, this.actualInfoVehicle);
            }
          }
        }
        this.getHistoryRoute();
      }
    },
    getHistoryRoute() {
      const url = `${store.getters.urlAPI}/api/history`;
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };
      this.bodyHistoryRequest.forEach(async (body) => {
        try {
          const response = await axios.post(url, body, config);
          // Handle the response as needed
          const data = response.data.data;
          if (data && data.id) {
            this.getStatusHistory(data.id);
          }
        } catch (e) {
          console.log(e);
        }
      });
      // Implement the logic to get the history route
    },
    async getStatusHistory(id, startTime = Date.now()) {
      const url = `${store.getters.urlAPI}/api/history-status`;
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.post(url, id, config);
        const data = response.data.data;
        if (data?.status === 'RUNNING') {
          // Si no han pasado más de 5 minutos, vuelve a consultar en 3 segundos
          if (Date.now() - startTime < 300000) {
            this.statusHistoryTimeoutIds[id] = setTimeout(() => {
              this.getStatusHistory(id, startTime);
            }, 3000);
          } else {
            console.log('Tiempo de espera agotado para history-status');
          }
        } else if (data?.status === 'SUCCEEDED') {
          const historyPoints = data.historyPoints;
          if (historyPoints && historyPoints.length > 0) {
            const transformed = historyPoints.map((p) => ({
              lat: p.lat,
              lng: p.lon,
              gpsDate: p.gpsDate < 1e12 ? p.gpsDate * 1000 : p.gpsDate,
            }));
            this.historyRoute.push(...transformed);
            this.historyRoute.sort((a, b) => a.gpsDate - b.gpsDate);
            await this.waitForElm('#googleMap');
            if (this.selectedTab == 'seguimiento') {
              this.$refs.googleMap.addPointToRealTime(this.historyRoute, this.actualInfoVehicle);
            }
          } else {
            console.log('Hubo un error al consultar el history', data);
          }
        }
      } catch (e) {
        console.log('Error generico del history ', e);
      }
    },
    getVehicleToListen() {
      if (this.route.assignations && this.route.assignations.length > 0) {
        this.route.assignations.forEach((assignation) => {
          if (
            assignation.state == 'ONGOING' ||
            assignation.state == 'ENDED' ||
            assignation.state == 'ENDEDINCOMPLETE'
          ) {
            const timeZone = store.getters.timeZone;
            const offsetHours = momentTz.tz(timeZone).utcOffset() / 60;
            const desde = assignation.actualStartDate
              ? this.formatDate(assignation.actualStartDate, 'YYYY-MM-DD HH:mm:ss')
              : this.formatDate(assignation.startDate, 'YYYY-MM-DD HH:mm:ss');

            const hasta = assignation.actualEndDate
              ? this.formatDate(assignation.actualEndDate, 'YYYY-MM-DD HH:mm:ss')
              : this.formatDate(assignation.endDate, 'YYYY-MM-DD HH:mm:ss');

            this.bodyHistoryRequest.push({
              listPatentes: [assignation.vehicle.plate],
              desde: desde,
              hasta: hasta,
              clientId: assignation.vehicle.idClient,
              zoneOffset: offsetHours,
              offSet: String(offsetHours),
              zoneId: timeZone,
            });
          }
          if (assignation.state == 'ONGOING' && assignation.vehicle.id_vehicle_operaciones) {
            this.listOfIdsVehicle.push(assignation.vehicle.id_vehicle_operaciones);
            if (assignation.cargo) {
              this.listOfIdsCargo.push(assignation.cargo.id_vehicle_operaciones);
            }
            if (assignation.gpsControl) {
              this.listOfIdsGpsControl.push(assignation.gpsControl.id_vehicle_operaciones);
            }
          }
        });
        this.listOfIdsVehicle = [...new Set(this.listOfIdsVehicle)];
        this.listOfIdsCargo = [...new Set(this.listOfIdsCargo)];
        this.listOfIdsGpsControl = [...new Set(this.listOfIdsGpsControl)];

        return [...this.listOfIdsVehicle, ...this.listOfIdsCargo, ...this.listOfIdsGpsControl];
      } else {
        return this.listOfIdsVehicle;
      }
    },
    async getRealTimeGPSVehicle(listOfIdsResources) {
      console.log('idsenviar', listOfIdsResources.toString());
      this.sendMessage(listOfIdsResources.toString());

      //listOfIdsResources = [500, 501, 502, 503];
      if (listOfIdsResources.length > 0) {
        this.latestPositionVehicles = await this.getLatestLocation(listOfIdsResources);
        const idToFind = this.listOfIdsVehicle[0];
        this.actualInfoVehicle.id = idToFind;
        if (this.latestPositionVehicles.length > 0) {
          //Se encarga de traer el dato del latest que corresponda al vehiculo
          const matchedVehicle = this.latestPositionVehicles.find((v) => v.vehicleId === idToFind);
          this.actualInfoVehicle.speed = this.truncate(matchedVehicle.speed);
          this.actualInfoVehicle.gpsDate = matchedVehicle.fechaEmision;
          this.actualInfoVehicle.state = matchedVehicle.estadoNuevo;
          this.actualInfoVehicle.lat = matchedVehicle.lat;
          this.actualInfoVehicle.lon = matchedVehicle.lon;
        }
      }
      this.isLatestDetailBusy = false;
    },
    addWaypointSpots(secureZones, idSpots) {
      this.trips.forEach((trip, index) => {
        trip.waypoint = [];
        trip.widthRoute = 6;
        trip.routeColor = '#F916C1';
        idSpots.push(trip.idOrigin);
        if (index == this.trips.length - 1) {
          idSpots.push(trip.idDestination);
        }
        if (secureZones) {
          secureZones.forEach((secureTrip) => {
            if (trip.idOrigin == secureTrip.idSpotOrigin && trip.idDestination == secureTrip.idSpotDestination) {
              trip.widthRoute = secureTrip.pathWidth <= 100 ? secureTrip.pathWidth / 10 : 15;
              trip.routeColor = '#8855AE';
              secureTrip.waypoint.forEach((wayp) => {
                trip.waypoint.push({
                  location: {
                    lat: wayp.lat,
                    lng: wayp.lon,
                  },
                  stopover: false,
                });
              });
            }
          });
        }
      });
      return idSpots;
    },
    //Llamadas a los endpoint
    async getSecureRoutes() {
      const urlAlert = `${store.getters.urlAPI}/secureZone`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const dataSecureRoutes = await axios.get(urlAlert, config);
        return dataSecureRoutes.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    getStorageValue(key) {
      try {
        return localStorage.getItem(key) || sessionStorage.getItem(key) || '';
      } catch (e) {
        return '';
      }
    },
    async getClientAreas() {
      const url = `${store.getters.urlAPI}/api/areas`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            JSESSIONID: store.getters.jsessionid,
            wpsid: store.getters.wpsid,
          },
        };
        const response = await axios.get(url, config);
        const payload = response?.data;
        const list = payload?.data?.[0]?.lista;
        if (Array.isArray(list)) return list;
        return payload?.lista ?? payload ?? [];
      } catch (e) {
        console.log('[getClientAreas] error', e);
        return [];
      }
    },
    normalizeAreaZones(rawAreas) {
      if (!Array.isArray(rawAreas)) return [];

      const toNumber = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      const normalizePoint = (p) => {
        if (!p) return null;
        const lat = toNumber(p.lat ?? p.latitude ?? p.Lat ?? p.LAT ?? p.y ?? (Array.isArray(p) ? p[1] : null));
        const lon = toNumber(p.lon ?? p.lng ?? p.longitude ?? p.LON ?? p.x ?? (Array.isArray(p) ? p[0] : null));
        if (lat == null || lon == null) return null;
        const radio = toNumber(p.radio ?? p.radius);
        return radio != null ? { lat, lon, radio } : { lat, lon };
      };

      const buildZoneFromItem = (item, index) => {
        if (!item) return null;
        const zoneId = item.id ?? index;
        const zoneName = item.nombre ?? item.name ?? '';
        const zoneColor = item.color ?? '#6226F7';

        // Prioridad 1: item.points (array ya decodificado por el backend)
        if (Array.isArray(item.points) && item.points.length > 0) {
          const points = item.points.map(normalizePoint).filter(Boolean);
          if (points.length > 0) return { id: zoneId, name: zoneName, color: zoneColor, points };
        }

        // Prioridad 2: encodedPoints string (fallback — compatibilidad con backends sin actualizar)
        const encoded = item.encodedPoints;
        if (typeof encoded === 'string' && encoded.length > 0) {
          const decoded = this.decodePolyline(encoded);
          const points = decoded.map((p) => ({ lat: p.lat, lon: p.lng }));
          if (points.length > 0) return { id: zoneId, name: zoneName, color: zoneColor, points };
        }

        // Prioridad 3: otros campos candidatos
        const candidates = item.zone || item.polygon || item.coordinates || item.area || item.path;
        if (typeof candidates === 'string' && candidates.length > 0) {
          const decoded = this.decodePolyline(candidates);
          const points = decoded.map((p) => ({ lat: p.lat, lon: p.lng }));
          return points.length > 0 ? { id: zoneId, name: zoneName, color: zoneColor, points } : null;
        }
        if (Array.isArray(candidates)) {
          const points = candidates.map(normalizePoint).filter(Boolean);
          return points.length > 0 ? { id: zoneId, name: zoneName, color: zoneColor, points } : null;
        }
        if (item.center && (item.radius || item.radio)) {
          const centerPoint = normalizePoint({ ...item.center, radius: item.radius ?? item.radio });
          return centerPoint ? { id: zoneId, name: zoneName, color: zoneColor, points: [centerPoint] } : null;
        }
        if ((item.lat || item.latitude) && (item.lon || item.lng || item.longitude)) {
          const zonePoint = normalizePoint(item);
          return zonePoint ? { id: zoneId, name: zoneName, color: zoneColor, points: [zonePoint] } : null;
        }
        return null;
      };

      console.log('[normalizeAreaZones] rawAreas length:', Array.isArray(rawAreas) ? rawAreas.length : 'not-array');
      const zones = rawAreas
        .map(buildZoneFromItem)
        .filter((z) => z && Array.isArray(z.points) && z.points.length > 0);

      if (zones.length > 0) {
        console.log('[normalizeAreaZones] first zone points:', zones[0].points);
      } else {
        console.log('[normalizeAreaZones] no zones decoded');
        console.log('[normalizeAreaZones] first raw item:', rawAreas[0]);
      }

      return zones;
    },
    decodePolyline(encoded) {
      let points = [];
      let index = 0;
      let lat = 0;
      let lng = 0;

      while (index < encoded.length) {
        let b;
        let shift = 0;
        let result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += dlat;

        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += dlng;

        points.push({ lat: lat / 1e5, lng: lng / 1e5 });
      }
      return points;
    },
    truncate(num, dec = 2) {
      const factor = Math.pow(10, dec);
      return Math.trunc(num * factor) / factor;
    },
    async getLatestLocation(vehicleIds) {
      const urlRoute = `${store.getters.urlAPI}/api/latest`;
      try {
        const body = {
          vehicleIds: vehicleIds,
        };
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const result = await axios.post(urlRoute, body, config);
        return result.data.data;
      } catch (e) {
        console.log(e);
        return {
          id: null,
          speed: null,
          gpsDate: 0,
          state: null,
          lat: null,
          lon: null,
        };
      }
    },
    async getRouteDetail() {
      const urlRoute = `${store.getters.urlAPI}/route/${this.idRoute}`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.get(urlRoute, config);
        return routesPromise.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    socketOnMessage() {
      this.socket.onmessage = async (event) => {
        // Se hace un parse de la data que llega a formato JSON
        let parsedMessage = JSON.parse(event.data);
        // Si los mensajes son distintos a undefined guarda la ubicacion entrante
        if (typeof parsedMessage !== 'undefined') {
          let pointSort = parsedMessage.data.sort((a, b) => a.gpsData.utc - b.gpsData.utc);
          pointSort.forEach((point) => {
            // Posicion de la carga
            try {
              if (this.listOfIdsCargo.includes(point.vehicleId)) {
                if (
                  !this.actualLocationCargo ||
                  (this.actualLocationCargo != null && this.actualLocationCargo.gpsData.utc < point.gpsData.utc)
                ) {
                  this.actualLocationCargo = point;
                  return;
                }
              }
              if (this.listOfIdsGpsControl.includes(point.vehicleId)) {
                if (
                  !this.actualLocationGpsControl ||
                  (this.actualLocationGpsControl != null &&
                    this.actualLocationGpsControl.gpsData.utc < point.gpsData.utc)
                ) {
                  this.actualLocationGpsControl = point;
                  return;
                }
              }
            } catch (err) {
              console.log(err);
            }

            if (
              this.actualInfoVehicle == null ||
              (this.actualInfoVehicle != null && this.actualInfoVehicle.gpsDate < point.gpsData.utc)
            ) {
              this.actualInfoVehicle.lat = point.gpsData.latitud;
              this.actualInfoVehicle.lon = point.gpsData.longitud;
              this.actualInfoVehicle.speed = this.truncate(point.speed);
              this.actualInfoVehicle.gpsDate = point.gpsData.utc;
              this.actualInfoVehicle.state = point.gpsData.estadoNuevo;
              this.historyRoute.push({
                gpsDate: point.gpsData.utc,
                lat: point.gpsData.latitud,
                lng: point.gpsData.longitud,
              });
            }
          });
          console.log('mensaje ', this.actualInfoVehicle);
          console.log('mensaje cargo', this.actualLocationCargo);
          console.log('mensaje gps control', this.actualLocationGpsControl);
          if (this.selectedTab === 'seguimiento') {
            await this.waitForElm('#googleMap');
            if (this.actualLocationCargo) this.$refs.googleMap.updateRealTimeCargo(this.actualLocationCargo);
            if (this.actualLocationGpsControl)
              this.$refs.googleMap.updateRealTimeGpsControl(this.actualLocationGpsControl);
            this.$refs.googleMap.addPointToRealTime(this.historyRoute, this.actualInfoVehicle);
          }
        }
      };
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    /**
     * Metodo para enviar un mensaje por websocket, si el socket esta en un estado diferente a OPEN intentara esperar hasta que le permita enviar el mensaje o tirar un error
     * @param {*} message
     */
    async sendMessage(message) {
      if (this.socket.readyState !== this.socket.OPEN) {
        try {
          await this.waitForOpenConnection(this.socket);
          this.socket.send(message);
        } catch (err) {
          console.error(err);
        }
      } else {
        this.socket.send(message);
      }
    },
    /**
     * Este metodo se utiliza por si al momento de querer enviar el  mensaje, si este falla arroja un error de conexion
     * @returns
     */
    waitForOpenConnection() {
      return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 10;
        const intervalTime = 200;

        let currentAttempt = 0;
        const interval = setInterval(() => {
          if (currentAttempt > maxNumberOfAttempts - 1) {
            clearInterval(interval);
            reject(new Error('Maximum number of attempts exceeded.'));
          } else if (this.socket.readyState === this.socket.OPEN) {
            clearInterval(interval);
            resolve();
          }
          currentAttempt++;
        }, intervalTime);
      });
    },
    formatDate(date, format) {
      //Si date es undefined, quiere decir que el conductor aun no ha empezado/llegado.
      if (date === undefined) {
        return ' -- | -- ';
      }
      return moment(date).format(format);
    },
    formatDuration(seconds, showSeconds = false) {
      if (seconds === undefined || seconds === null || seconds === 0) return null;
      const duration = moment.duration(seconds, 'seconds');
      const hours = String(duration.hours()).padStart(2, '0');
      const minutes = String(duration.minutes()).padStart(2, '0');
      if (showSeconds) {
        const secs = String(duration.seconds()).padStart(2, '0');
        return `${hours}:${minutes}:${secs}`;
      }
      return `${hours}:${minutes}`;
    },
    async toggleCollapse(tripId, index, assignationId) {
      const isOpen = !this.collapseStates[tripId];
      this.simpleToggleCollapse(tripId);

      if (isOpen && assignationId != undefined && assignationId != null) {
        let trip = this.trips.find((t) => t.id === tripId);
        if (!trip) return;

        if (!trip.lastEstimateCalc) trip.lastEstimateCalc = 0;
        const now = Date.now();
        if (now - trip.lastEstimateCalc > 300000 && trip.state == 'INTRANSIT') {
          this.actualAsignation = assignationId;
          let response = await this.getInTransitTripDetail();

          let estimatedDate = this.calculateEstimatedTime(response, tripId);
          if (trip && trip.departureDestination) {
            this.$set(this.trips, index, {
              ...trip,
              departureDestination: { ...trip.departureDestination, est: estimatedDate },
            });
            trip.lastEstimateCalc = now;
          }
        }
      }
    },
    getUsername(username) {
      if (!username || typeof username !== 'string') return '';
      if (username.toUpperCase() === 'SYSTEM') return this.t('routeDetailModalV2.eventsLog.systemUser');
      return username;
    },
    getIconEvent(eventType) {
      return EVENT_ICON_MAP[eventType?.toString().toUpperCase()] || null;
    },
    getNameEvent(eventType, metaData) {
      // Si eventType es un número entre 101 y 199
      const eventTypeNum = Number(eventType?.toString().trim());
      if (!Number.isNaN(eventTypeNum) && eventTypeNum >= 101 && eventTypeNum <= 199 && metaData) {
        const alertType = this.getAssignMetadata(metaData, 'nameEvent');
        // Usando la traducción con parámetro
        return this.t('routeDetailModalV2.eventsLog.channelAlert.alertOf', { alertType });
      }
      // Caso normal
      const key = EVENT_NAME_MAP[eventType?.toString().toUpperCase()];
      return key ? this.t(`routeDetailModalV2.eventsLog.${key}`) : '';
    },
    getPlannedDateTitle(eventType) {
      const key = EVENT_PLANNED_TITLE_MAP[eventType?.toString().toUpperCase()];
      return key ? this.t(`routeDetailModalV2.eventsLog.channelHandledTrip.${key}`) : '';
    },
    getDataForStateTrip(eventType, metadata) {
      const type = eventType?.toString().toUpperCase();
      if (type === 'TRIP.START') return this.formatDate(this.getAssignMetadata(metadata, 'start_date'), 'DD/MM HH:mm');
      if (type === 'TRIP.ARRIVE')
        return this.formatDate(this.getAssignMetadata(metadata, 'arrival_date'), 'DD/MM HH:mm');
      if (type === 'TRIP.END') return this.formatDuration(this.getAssignMetadata(metadata, 'actual_duration'), true);
      return null;
    },
    isRouteCancel(eventType) {
      return eventType?.toString().toUpperCase() === 'ROUTE.CANCEL';
    },
    getDataForStateRealTrip(entry) {
      const value = entry.createdAt;
      return this.formatDate(value, 'DD/MM/YYYY HH:mm');
    },
    getDelayForStateTrip(eventType, metadata) {
      const THRESHOLD_SECONDS = 300; // 5 minutos

      if (eventType?.toString().toUpperCase() === 'TRIP.START') {
        const real = this.getAssignMetadata(metadata, 'actual_start_date'); // milisegundos
        const scheduled = this.getAssignMetadata(metadata, 'start_date'); // milisegundos
        if (real && scheduled) {
          const diffSeconds = Math.floor((real - scheduled) / 1000);
          if (diffSeconds > THRESHOLD_SECONDS) {
            return this.formatDuration(diffSeconds);
          }
        }
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.noDelay');
      }

      if (eventType?.toString().toUpperCase() === 'TRIP.ARRIVE') {
        const real = this.getAssignMetadata(metadata, 'actual_arrival_date'); // milisegundos
        const scheduled = this.getAssignMetadata(metadata, 'arrival_date'); // milisegundos
        if (real && scheduled) {
          const diffSeconds = Math.floor((real - scheduled) / 1000);
          if (diffSeconds > THRESHOLD_SECONDS) {
            return this.formatDuration(diffSeconds);
          }
        }
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.noDelay');
      }

      if (eventType?.toString().toUpperCase() === 'TRIP.END') {
        const real = this.getAssignMetadata(metadata, 'actual_duration'); // segundos
        const scheduled = this.getAssignMetadata(metadata, 'duration'); // segundos
        if (real && scheduled) {
          const diffSeconds = Math.floor(real - scheduled);
          if (diffSeconds > THRESHOLD_SECONDS) {
            return this.formatDuration(diffSeconds);
          }
        }
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.noDelay');
      }

      return '-';
    },
    isRouteStartEvent(eventType) {
      return eventType?.toString().toUpperCase() === 'ROUTE.START';
    },
    isRouteEndEvent(eventType) {
      return eventType?.toString().toUpperCase() === 'ROUTE.END';
    },
    isAssignEvent(eventType) {
      return (
        eventType?.toString().toUpperCase() === 'ASSIGNATION.ASSIGN' ||
        eventType?.toString().toUpperCase() === 'ASSIGNATION.UNASSIGN'
      );
    },
    isTripStateEvent(eventType) {
      return (
        eventType?.toString().toUpperCase() === 'TRIP.START' ||
        eventType?.toString().toUpperCase() === 'TRIP.ARRIVE' ||
        eventType?.toString().toUpperCase() === 'TRIP.END'
      );
    },
    requireTripName(eventType) {
      const numType = Number(eventType);
      return (
        eventType?.toString().toUpperCase() === 'TRIP.START' ||
        eventType?.toString().toUpperCase() === 'TRIP.ARRIVE' ||
        eventType?.toString().toUpperCase() === 'TRIP.END' ||
        (!Number.isNaN(numType) && numType >= 101 && numType <= 199)
      );
    },
    isMovingEvent(eventType) {
      const MOVING_EVENTS = ['TRIP.START', 'TRIP.ARRIVE', 'TRIP.END', 'ROUTE.START', 'ROUTE.END'];
      const type = eventType?.toString().toUpperCase();
      return MOVING_EVENTS.includes(type);
    },
    isAlertEvent(eventType) {
      const numType = Number(eventType);
      return !Number.isNaN(numType) && numType >= 101 && numType <= 199;
    },
    isEditEvent(eventType) {
      return (
        eventType?.toString().toUpperCase() === 'ROUTE.EDIT' ||
        eventType?.toString().toUpperCase() === 'TRIP.EDIT' ||
        eventType?.toString().toUpperCase() === 'ACTIVITY.EDIT'
      );
    },
    getAssignMetadata(metadata, dataType) {
      if (!metadata || !dataType) return '-';

      const assignData = metadata[dataType];
      if (!assignData) return '-';

      // Si es un array, usa listToText para formatear
      if (Array.isArray(assignData)) {
        return this.listToText(assignData);
      }
      return assignData;
    },
    getChannelTitleDetails(eventType) {
      if (eventType?.toString().toUpperCase() === 'ROUTE.CREATION') {
        return this.t('routeDetailModalV2.eventsLog.channelCreated.title');
      } else if (this.isRouteStartEvent(eventType)) {
        return this.t('routeDetailModalV2.eventsLog.routeStartMechanism');
      } else if (this.isRouteEndEvent(eventType)) {
        return this.t('routeDetailModalV2.eventsLog.routeEndMechanism');
      } else if (eventType?.toString().toUpperCase() === 'ASSIGNATION.ASSIGN') {
        return this.t('routeDetailModalV2.eventsLog.channelAssigned.titleAssign');
      } else if (eventType?.toString().toUpperCase() === 'ASSIGNATION.UNASSIGN') {
        return this.t('routeDetailModalV2.eventsLog.channelAssigned.titleUnassign');
      } else if (eventType?.toString().toUpperCase() === 'TRIP.START') {
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.titleStart');
      } else if (eventType?.toString().toUpperCase() === 'TRIP.ARRIVE') {
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.titleArrive');
      } else if (eventType?.toString().toUpperCase() === 'TRIP.END') {
        return this.t('routeDetailModalV2.eventsLog.channelHandledTrip.titleEnd');
      }
    },
    getChannelCreatedDetails(event) {
      const channel = event.channel;
      const eventType = event.eventType;
      if (
        this.isRouteStartEvent(eventType) ||
        this.isRouteEndEvent(eventType) ||
        eventType?.toString().toUpperCase() === 'TRIP.START' ||
        eventType?.toString().toUpperCase() === 'TRIP.ARRIVE' ||
        eventType?.toString().toUpperCase() === 'TRIP.END'
      ) {
        if (event.source === 1) {
          return 'Web';
        } else if (event.source === 2) {
          return 'App';
        } else if (event.source === 3) {
          return 'GPS';
        }
      }
      if (channel == CHANNEL.API) {
        return this.t('routeDetailModalV2.eventsLog.channelCreated.api');
      } else if (channel == CHANNEL.PLANTILLA) {
        return this.t('routeDetailModalV2.eventsLog.channelCreated.template');
      } else if (channel == CHANNEL.MANUAL) {
        return this.t('routeDetailModalV2.eventsLog.channelCreated.manual');
      } else if (channel == CHANNEL.MASIVA) {
        return this.t('routeDetailModalV2.eventsLog.channelCreated.massive');
      }
    },
    simpleToggleCollapse(id) {
      const isOpen = !this.collapseStates[id];
      this.$set(this.collapseStates, id, isOpen);
    },
    calculateEstimatedTime(response, idTrip) {
      if (response !== null && response.idTrip === idTrip) {
        const arrivalEstimateMs = response.etaDateAnalized + response.estimatedTime * 1000;
        return this.formatDate(arrivalEstimateMs, 'DD/MM HH:mm');
      }
      return null;
    },
    async getInTransitTripDetail() {
      const urlRoute = `${store.getters.urlAPI}/assignation/${this.actualAsignation}/inTransitTripDetail`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    t(key, value) {
      return i18n.t(key, value);
    },
    getStateName(tripState) {
      return this.t(`routeDetailModalV2.statusTrip.${tripState}`);
    },
    getDrivingStateName(vehicleState) {
      return this.t(`routeDetailModalV2.statusDriving.${vehicleState.toUpperCase()}`);
    },
    dateToInteger(date) {
      const dateTemp = new Date(date);
      return dateTemp.getTime();
    },
    async transformTrip(trip, index, assignVehicleDriver) {
      let [vehiclePlate, driverName, cargoPlate] = this.obtainDriverVehicle(assignVehicleDriver, trip);
      //const dataSources = [1, 2, 3];
      //trip.actualStartDateSource = dataSources[index % dataSources.length];
      //trip.actualArrivalDateSource = dataSources[index % dataSources.length];
      trip.actualStartDateSource = this.getSourceLabel(trip.actualStartDateSource);
      trip.actualArrivalDateSource = this.getSourceLabel(trip.actualArrivalDateSource);

      trip.departureOrigin = this.buildDepartureOrigin(trip);
      trip.departureDestination = this.buildDepartureDestination(trip);
      trip.durationDates = this.buildDurationDates(trip);

      trip.vehicle = vehiclePlate || this.getNotAssignedVehicle();
      trip.driver = driverName || this.getNotAssignedDriver();
      trip.cargo = cargoPlate || this.getNotAssignedCargo();

      trip.idOrigin = trip.origin ? trip.origin.id : 'no encontrado';
      trip.idDestination = trip.destination ? trip.destination.id : 'no encontrado';
      trip.originAddress = trip.origin ? trip.origin.address : 'no encontrado';
      trip.destinationAddress = trip.destination ? trip.destination.address : 'no encontrado';
      trip.coordinates = {
        origin: {
          lat: trip.origin ? trip.origin.address.lat : 0,
          lng: trip.origin ? trip.origin.address.lon : 0,
        },
        destination: {
          lat: trip.destination ? trip.destination.address.lat : 0,
          lng: trip.destination ? trip.destination.address.lon : 0,
        },
      };
      trip.extraField = trip.extraData ? trip.extraData.extraData1 : null;
      trip.tripOrder = this.dateToInteger(trip.startDate);
    },
    getSourceLabel(sourceIndex) {
      return this.t(`routeDetailModalV2.source[${sourceIndex - 1}]`);
    },
    goToActivities(tripId) {
      showRouteDetail(this.idRoute, null, 'viewV2', tripId);
    },
    buildDepartureOrigin(trip) {
      const originReal = trip.actualStartDate ? new Date(trip.actualStartDate).getTime() : null;
      const originScheduled = trip.startDate ? new Date(trip.startDate).getTime() : null;

      let delayed = null;
      if (originReal && originScheduled && originReal - originScheduled > 300000) {
        // Si cumple la regla, guarda la diferencia en HH:mm
        const diffSeconds = Math.floor((originReal - originScheduled) / 1000);
        delayed = this.formatDuration(diffSeconds);
      }

      return {
        real: trip.actualStartDate !== undefined ? this.formatDate(trip.actualStartDate, 'DD/MM HH:mm') : null,
        scheduled: this.formatDate(trip.startDate, 'DD/MM HH:mm'),
        est: this.t(`routeDetailModalV2.gettingLocation`),
        delayed: delayed,
      };
    },

    buildDepartureDestination(trip) {
      let destReal = null;
      if (trip.actualDrivingTime > 0 && trip.actualStartDate) {
        destReal = new Date(new Date(trip.actualStartDate).getTime() + trip.actualDrivingTime * 1000).getTime();
      } else if (trip.actualArrivalDate) {
        destReal = new Date(trip.actualArrivalDate).getTime();
      }
      const destScheduled =
        trip.startDate && trip.drivingTime
          ? new Date(new Date(trip.startDate).getTime() + trip.drivingTime * 1000).getTime()
          : null;

      let delayed = null;
      if (destReal && destScheduled && destReal - destScheduled > 300000) {
        // Si cumple la regla, guarda la diferencia en HH:mm
        const diffSeconds = Math.floor((destReal - destScheduled) / 1000);
        delayed = this.formatDuration(diffSeconds);
      }

      return {
        real:
          trip.actualDrivingTime > 0
            ? this.formatDate(this.dateToInteger(trip.actualStartDate) + trip.actualDrivingTime * 1000, 'DD/MM HH:mm')
            : trip.actualArrivalDate
            ? this.formatDate(trip.actualArrivalDate, 'DD/MM HH:mm')
            : null,
        scheduled: this.formatDate(this.dateToInteger(trip.startDate) + trip.drivingTime * 1000, 'DD/MM HH:mm'),
        est: this.t(`routeDetailModalV2.gettingLocation`),
        delayed: delayed,
      };
    },
    buildDurationDates(trip) {
      let delayed = null;
      if (trip.actualDuration && trip.duration && (trip.actualDuration - trip.duration) * 1000 > 300000) {
        // Si cumple la regla, guarda la diferencia en HH:mm
        const diffSeconds = Math.floor(trip.actualDuration - trip.duration);
        delayed = this.formatDuration(diffSeconds);
      }

      return {
        scheduled: this.formatDuration(trip.duration),
        real: this.formatDuration(trip.actualDuration),
        delayed: delayed,
      };
    },
    getNotAssignedVehicle() {
      return { vehiclePlate: this.t(`routeDetailModalV2.notAssigned`), state: 'NOTASSIGNED' };
    },
    getNotAssignedDriver() {
      return { driverName: this.t(`routeDetailModalV2.notAssigned`), state: 'NOTASSIGNED' };
    },
    getNotAssignedCargo() {
      return { cargoPlate: '-', state: 'NOTASSIGNED' };
    },
    obtainDriverVehicle(assignVehicleDriver, trip) {
      let vehiclePlate = null,
        driverName = null,
        cargoPlate = null;
      if (trip.idAssignation != null) {
        const [driver, vehicle, state, cargo] = assignVehicleDriver.get(trip.idAssignation) || [];
        if (vehicle) {
          vehiclePlate = {
            vehicle,
            vehiclePlate: vehicle.plate || null,
            state,
          };
        }
        if (driver) {
          driverName = {
            driver,
            driverName:
              driver.firstName && driver.lastName
                ? `${this.transformWords(driver.firstName)} ${this.transformWords(driver.lastName)}`
                : null,
            state,
          };
        }
        if (cargo) {
          cargoPlate = {
            vehicle: cargo,
            cargoPlate: cargo.plate || null,
            state,
          };
        }
      }
      return [vehiclePlate, driverName, cargoPlate];
    },
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    getStepColor(state) {
      switch (state) {
        case 'NOTSTARTED':
          return '#9167F9'; // morado
        case 'INTRANSIT':
          return '#F79009'; // naranja
        case 'ATDESTINATION':
        case 'ENDED':
          return '#11891C'; // verde
        case 'NOTENDED':
        case 'POSTPONED':
          return '#D92D20'; // rojo
        default:
          return '#B9EABD'; // gris/verde claro por defecto
      }
    },
    getStepClearColor(state) {
      switch (state) {
        case 'NOTSTARTED':
          return '#D0BEFD'; // morado
        case 'INTRANSIT':
          return '#FEDF89'; // naranja
        case 'ATDESTINATION':
        case 'ENDED':
          return '#B9EABD'; // verde
        case 'NOTENDED':
        case 'POSTPONED':
          return '#FDA29B'; // rojo
        default:
          return '#B9EABD'; // gris/verde claro por defecto
      }
    },
    getStepLineStyle(state, style) {
      const color = style === 'dashed' ? this.getStepClearColor(state) : this.getStepColor(state);
      return {
        borderLeft: `3px ${style} ${color}`,
      };
    },
    onHidden() {
      Object.values(this.statusHistoryTimeoutIds).forEach((timeoutId) => clearTimeout(timeoutId));
      this.statusHistoryTimeoutIds = {};
      if (this.socket && this.routeIsOngoing) {
        this.socket.close();
      }
      this.$destroy();
      this.$el.remove();
    },
    async buildVehicleAndTruckDetails() {
      this.buildVehicleAndTruckIdAndPlate();
    },
    async openInfoVehicleAndTruck() {
      this.showLatestRow2 = !this.showLatestRow2;
      await this.openInfoVehicle();
      await this.openInfoTruck();
    },
    async openInfoVehicle() {
      if (this.showLatestRow2) {
        const data = await this.loadSignalGpsOnce();
        if (data != undefined && data.length > 0) {
          data.forEach((signal) => {
            if (this.vehicleDetails.id == signal.idVehicle) {
              if (signal.equipment && signal.equipment.length > 0) {
                let equipments = [];
                signal.equipment.forEach((equipment) => {
                  equipments.push(this.transformWords(equipment));
                });
                this.vehicleDetails.equipments = equipments;
              }
              if (signal.notification && signal.notification.length > 0) {
                let notifications = [];
                signal.notification.forEach((notification) => {
                  notifications.push(this.transformWords(notification));
                });
                this.vehicleDetails.configuredAlerts = notifications;
              }
            }
          });
        }
      }
    },
    async openInfoTruck() {
      if (this.showLatestRow2) {
        const data = await this.loadSignalGpsOnce();
        if (data != undefined && data.length > 0) {
          data.forEach((signal) => {
            if (this.truckDetails.id == signal.idVehicle) {
              if (signal.equipment && signal.equipment.length > 0) {
                let equipments = [];
                signal.equipment.forEach((equipment) => {
                  equipments.push(this.transformWords(equipment));
                });
                this.truckDetails.equipments = equipments;
              }
              if (signal.notification && signal.notification.length > 0) {
                let notifications = [];
                signal.notification.forEach((notification) => {
                  notifications.push(this.transformWords(notification));
                });
                this.truckDetails.configuredAlerts = notifications;
              }
            }
          });
        }
      }
    },
    buildVehicleAndTruckIdAndPlate() {
      if (!this.route?.assignations?.length) return;
      this.route.assignations.forEach((a) => {
        if (a.state !== 'ONGOING') return;

        if (a.vehicle?.id) {
          this.vehicleDetails.plate = a.vehicle?.plate;
          this.vehicleDetails.id = a.vehicle?.id;
        }
        if (a.cargo?.id) {
          this.truckDetails.plate = a.cargo?.plate;
          this.truckDetails.id = a.cargo?.id;
        }
      });
    },
    buildVehicleIdList() {
      const ids = [];
      if (!this.route?.assignations?.length) return ids;

      this.route.assignations.forEach((a) => {
        if (a.state !== 'ONGOING') return;

        if (a.vehicle?.id) ids.push(a.vehicle.id);
        if (a.cargo?.id) ids.push(a.cargo.id);
        if (a.gpsControl?.id) ids.push(a.gpsControl.id);
      });

      return [...new Set(ids)];
    },
    async loadSignalGpsOnce(force = false) {
      if (!force && this.signalGpsLoaded) return this.lastSignalGPS;
      if (this.signalGpsLoading) return this.lastSignalGPS;

      this.signalGpsLoading = true;
      try {
        const data = await this.getSignalGps();
        this.lastSignalGPS = data;
        if (data != null) this.signalGpsLoaded = true;
        return data;
      } finally {
        this.signalGpsLoading = false;
      }
    },
    async getSignalGps() {
      const urlGps = `${store.getters.urlAPI}/api/vehicleDetailByIdList`;

      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };

        const vehicleIds = this.buildVehicleIdList();
        if (vehicleIds.length === 0) return null;

        const resp = await axios.post(urlGps, vehicleIds, config);

        return resp.data.data;
      } catch (e) {
        console.error('[getSignalGps] error:', e);
        return null;
      }
    },
    isArrayWithItems(v) {
      return Array.isArray(v) && v.length > 0;
    },
    formatItem(item) {
      // Si son strings, queda tal cual.
      if (item == null) return '';
      if (typeof item === 'string' || typeof item === 'number') return String(item);

      // Si son objetos, ajusta a tu estructura real:
      return item.name || item.description || item.label || item.id || '';
    },
    listToText(list) {
      if (!Array.isArray(list) || list.length === 0) {
        return null;
      }

      return list
        .map((item) => this.formatItem(item))
        .filter(Boolean)
        .join(', ');
    },
    onToggleTraffic() {
      if (this.$refs.googleMap && typeof this.$refs.googleMap.toggleTraffic === 'function') {
        this.$refs.googleMap.toggleTraffic(this.showTrafficLevel);
      }
    },
    onToggleZones() {
      if (this.$refs.googleMap && typeof this.$refs.googleMap.toggleZones === 'function') {
        this.$refs.googleMap.toggleZones(this.showZones, this.normalizedZones);
      }
    },
    centerVehicleLocation() {
      if (!this.$refs.googleMap || typeof this.$refs.googleMap.centerOnVehicle !== 'function') return;
      const { lat, lon } = this.actualInfoVehicle || {};
      if (lat == null || lon == null) return;
      this.$refs.googleMap.centerOnVehicle(lat, lon, 17);
    },
    normalizeToSeconds(ts) {
      // Si es mayor a 1e12, asumimos que es milisegundos
      return ts > 1e12 ? Math.floor(ts / 1000) : ts;
    },
    rowClassByEventId(item) {
      // Si no hay ningún evento seleccionado, no aplica clase
      const selectedId = this.$refs.googleMap?.getEventIdSelected?.() ?? null;
      if (!selectedId) return '';
      // Compara el eventId de la fila con el seleccionado
      return item.eventId === selectedId;
    },
    async changeTab(tab) {
      if (tab === 'seguimiento') {
        this.selectedTab = 'seguimiento';
        await this.waitForElm('#googleMap');
        //Cuando vuelve a la pestaña de seguimiento debe cpoblar el mapa nuevamente
        await this.$refs.googleMap.setMapTrips(this.trips, this.showZones ? this.normalizedZones : null);
        await this.$refs.googleMap.setEvents(this.eventsInRoute);
        if (this.actualLocationCargo) this.$refs.googleMap.updateRealTimeCargo(this.actualLocationCargo);
        if (this.actualLocationGpsControl) this.$refs.googleMap.updateRealTimeGpsControl(this.actualLocationGpsControl);
        this.$refs.googleMap.addPointToRealTime(this.historyRoute, this.actualInfoVehicle);
      } else if (tab === 'bitacora') {
        this.selectedTab = 'bitacora';
      }
    },
    onEventRowClicked(item) {
      // Aquí puedes hacer lo que quieras con el evento clickeado
      // Ejemplo: seleccionar el evento en el mapa
      this.allowAutoPageChange = true;
      this.$refs.googleMap.centerAndOpenInfoWindow(item.eventId);
    },
    centerPageOnSelectedEvent() {
      const selectedId = this.$refs.googleMap?.getEventIdSelected?.() ?? null;
      this.allowAutoPageChange = this.$refs.googleMap?.getAllowedAutoPage?.() ?? false;
      if (!selectedId) return;
      const index = this.eventsInRouteOrder.findIndex((event) => event.eventId === selectedId);
      if (index === -1) return;
      const page = Math.floor(index / this.perPage) + 1;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }
    },
    onPageChanged(page) {
      this.currentPage = page;
      this.allowAutoPageChange = false; // Desactiva el cambio automático
    },
  },
  computed: {
    eventsLogsInOrder() {
      return this.eventsLog.map((event) => {
        return event;
      });
    },
    eventsInRouteOrder() {
      return this.eventsInRoute
        .slice() // copia para no mutar el original
        .sort((a, b) => b.initEvent - a.initEvent)
        .map((event, index) => {
          event.dateEvent = this.formatDate(event.initEvent, 'DD/MM/YYYY HH:mm');
          if (this.rowClassByEventId(event)) {
            const page = Math.floor(index / this.perPage) + 1;
            if (this.currentPage !== page && this.allowAutoPageChange) {
              this.currentPage = page;
              this.allowAutoPageChange = false;
            }
            event._rowVariant = 'danger';
          } else {
            event._rowVariant = '';
          }
          return event;
        });
    },
    eventDetailField() {
      const common = {
        thClass: 'text-left',
      };
      return [
        {
          key: 'nameEvent',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.eventType'),
          ...common,
        },
        {
          key: 'dateEvent',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.initEvent'),
          ...common,
        },
        {
          key: 'plate',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.vehicle'),
          ...common,
        },
        {
          key: 'driver',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.driver'),
          ...common,
        },
        {
          key: 'duration',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.duration'),
          ...common,
        },
        {
          key: 'address',
          tdClass: 'text-left',
          label: this.t('routeDetailModalV2.eventList.address'),
          ...common,
        },
      ];
    },
  },
  watch: {
    'actualInfoVehicle.speed'(newVal, oldVal) {
      if (oldVal === null || newVal === null) return;
      if (newVal > oldVal) {
        this.speedChangeDirection = 'up';
      } else if (newVal < oldVal) {
        this.speedChangeDirection = 'down';
      } else {
        this.speedChangeDirection = null;
      }
      // Quita la clase después de la animación (ej: 1s)
      setTimeout(() => {
        this.speedChangeDirection = null;
      }, 1000);
    },
  },
};
